export default [
  'input',
  'a',
  'button',
  'textarea',
  'select'
];



/** WEBPACK FOOTER **
 ** ./src/utils/control-elements.js
 **/